import type { ReactElement } from 'react';
import { Icon } from '@/components/atoms/icon';

export type CollectionTone = 'warm' | 'brand' | 'ok' | 'neutral';

const TONE_BG: Readonly<Record<CollectionTone, string>> = {
  warm: 'var(--warm-wash)',
  brand: 'var(--brand-wash)',
  ok: 'var(--ok-wash)',
  neutral: 'var(--bg-inset)',
};
const TONE_FG: Readonly<Record<CollectionTone, string>> = {
  warm: 'var(--warm)',
  brand: 'var(--brand)',
  ok: 'var(--ok)',
  neutral: 'var(--ink-2)',
};

export type CollectionCardProps = {
  name: string;
  pieceCount: number;
  toneKey: CollectionTone;
  onClick?: () => void;
};

export function CollectionCard({ name, pieceCount, toneKey, onClick }: CollectionCardProps): ReactElement {
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-left p-4 rounded-[var(--r-md)] border border-[var(--rule)] hover:border-[var(--ink)] transition-all"
      style={{ background: TONE_BG[toneKey] }}
    >
      <div
        className="w-10 h-10 rounded-full flex items-center justify-center"
        style={{ background: 'rgba(255,255,255,0.7)', color: TONE_FG[toneKey] }}
      >
        <Icon name="book" size={16} />
      </div>
      <div className="font-display text-[16px] font-semibold mt-3 text-[var(--ink)]">{name}</div>
      <div className="text-[11px] text-[var(--ink-3)] mt-1">{pieceCount === 1 ? '1 piece' : `${pieceCount} pieces`}</div>
    </button>
  );
}
